import React from 'react';
import Notification from '../messagerie_user/notification';
import CardAccueil from './cardAccueil';
import NavArbitre from '../navigation/navArbitre';

function ProfilArbitre(props) {

  return (
    <>
      <NavArbitre userData={props.userData} nom='Accueil'/>
      <div className="main profil_">
      <Notification userData = {props.userData}/>
      <CardAccueil nom={props.userData.user.donnée.results[0].nom} prenom={props.userData.user.donnée.results[0].prenom}/>
      <br/>
        <h2>Identité</h2>
        <div className="card">
          <div className="card-body">
            <table>
              <tbody>
                <tr>
                  <td>Nom</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].nom}</td>
                </tr>
                <tr>
                  <td>Prénom</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].prenom}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].email}</td>
                </tr>
                <tr>
                  <td>Numéro de téléphone</td>
                  <td>:</td>
                  <td> {props.userData.user.donnée.results[0].contact}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfilArbitre;
